// https://stackoverflow.com/questions/63961803/eslint-says-all-enums-in-typescript-app-are-already-declared-in-the-upper-scope
/* eslint-disable no-shadow */
export const SERVICE_PAGE_NAME = 'service-page';
export const SERVICE_PAGE_SLOT_ID = 'slot1';
export const SERVICE_LIST_PAGE_NAME = 'book-online';
export const ALLOW_DISCOUNT_FOR_BOOKING_ITEMS_EXPERIMENT =
  'specs.bookings.allowDiscountForBookingItems';
export const SHOW_DISCOUNT_EXPERIMENT = 'specs.bookings.AutomaticDiscountsUoU';

export const REPORT_BOOKING_ATTEMPT_BLOCKED_EXPERIMENT =
  'specs.bookings.ReportBookingAttemptBlocked';

export enum FailReasons {
  Premium = 'premium',
  PricingPlanNotInstalled = 'pricing_plan_not_installed',
  NoPlansAssignedToService = 'no_plans_assigned_to_service',
}
